module.exports = __webpack_public_path__ + "static/media/logo-python.cdf523ab.png";